import axios, {AxiosRequestConfig} from 'axios'
import configuration from '../configuration.json'
import { store } from '../state'
import { deleteAuthInfo,setAuthInfo } from '../state/auth'
const server = configuration.server
const BASEURL = `${server}/backend/rest/api/v26591/`

export const instance = axios.create({
  baseURL: BASEURL,
  responseType: 'json',
  timeout: 10000 * 3,
})

export const blobInstance = axios.create({
  baseURL: BASEURL,
  responseType: 'blob',
  timeout: 10000 * 300,
})

export const AuthInstance = axios.create({
  baseURL: BASEURL,
  responseType: 'json',
  timeout: 10000 * 3,
  auth: {
    username: configuration.oauthClientID,
    password: configuration.oauthClientSecret,
  },
})

const addAuthorizationToken = (config:AxiosRequestConfig) => {
 if (config.headers === undefined) {
      config.headers = {};
 }
  if (store.getState()?.auth?.auth) {
    const token = store.getState().auth.auth.access_token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
  }
  return config
}

const addForwardSlashForAllGetRequests = (config:AxiosRequestConfig) => {
  if (
    config.url &&
    config.url[config.url.length - 1] !== '/' &&
    config.method !== 'get'
  ) {
    config.url += '/'
  }
  return config
}

instance.interceptors.request.use(
  (config) => {
    config = addAuthorizationToken(config)
    config = addForwardSlashForAllGetRequests(config)
    return config
  },
  (error) => {
    Promise.reject(error).then(r => console.error(error))
  }
)

instance.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response && error.response.status === 401) {
        return AuthInstance.post('authentication/refresh_token/', {
                'refresh': store.getState().auth.auth.refresh_token,
                 'token':store.getState().auth.auth.access_token
            }).then(response => {
                const {auth,user}= store.getState().auth
                const t = {
                    ...auth,
                    access_token:response.data.access
                }
                store.dispatch(setAuthInfo({
                        auth:t,
                        user:user
                }))
                setTimeout(()=>{
                    error.response.config.headers['Authorization'] = 'Bearer ' + response.data.access;
                return instance.request(error.response.config);
                },10000)

            }).catch(error => {
                store.dispatch(deleteAuthInfo());
                return Promise.reject(error);
            }).finally();
    }
    return Promise.reject(error)
  }
)
